import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueScrollTo from 'vue-scrollto'
import VueCookies from 'vue-cookies'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import LazyLoadDirective from "./directives/LazyLoadDirective";
import ClickOutside from "./directives/ClickOutside.vue";

import './assets/styles/styles.scss'

Vue.config.productionTip = false

Object.defineProperty(Vue.prototype, '$mobView', {
  get () {
    return window.innerWidth<=840 ? true : false;
  }
})

Vue
  .use(VueCookies)
  .use(VueScrollTo)
  .use(VueLodash, { lodash: lodash })
  // .use(VueScrollReveal, {
  //   class: 'v-scroll-reveal', // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
  //   duration: 800,
  //   scale: 1,
  //   distance: '0',
  //   // mobile: false,
  //   desktop: true,
  //   mobile: true,
  //   // reset: true
  // })

Vue.directive("lazyload", LazyLoadDirective)
Vue.directive("click-outside", ClickOutside)

Vue.filter('declension', function (value, words) {
  return value + ' ' + words[
    (value %= 100, 20 > value && value > 4)
      ? 2
      : [2,0,1,1,1,2][(value %= 10, value < 5) ? value : 5]
    ];
})

Vue.filter('thousands', function (value) {
  return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
})

new Vue({
  router,
  store,
  VueScrollTo,
  render: h => h(App)
}).$mount('#app')
